import React, { useState, useEffect, useRef } from 'react';
import {
  TextField,
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableFooter,
  TablePagination,
  Menu,
  MenuItem,
  InputAdornment,
  Checkbox,
} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { AddCircle, DragIndicator, MoreHoriz, RemoveCircle } from '@material-ui/icons';
import CreateIcon from '@material-ui/icons/Create';
import TablePaginationActions from '../../../../../shared/table-pagination/TablePaginationActions';
import DeletePopupModel from '../../../../../shared/delete-popup/Delete-Popup';
import {
  PERSONALISATION_CREATE,
  PERSONALISATION_EDIT,
  PERSONALISATION_VIEW,
} from '../../../../../constants/AccomodationConst';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_HOTEL_ACCOMMODATIONS,
} from '../../../../../constants/RoleConsts';
import LinearProgressBar from '../../../../../shared/progress-bar/Progress';
import { useSelector, useDispatch } from 'react-redux';
import {
  allPersonalisationsSelector,
  fetchAllAccommodations,
  selectedHotelCurrencySelector,
  setAllPersonalisations,
} from '../../../../property/propertySlice';
import './Personalisation-List.scss';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ListFilterMenu from '../../../../../shared/list-filter-menu/List-Filter-Menu';
import CustomChip from '../../../../../shared/form-controls/custom-chip/Custom-Chip';
import {
  accommodationPersonalizationActivate,
  accommodationPersonalizationDeactivate,
  deleteAccommodationPersonalizationAPI,
  deleteSelectedItems,
  updateSelectedItemsStatus,
} from '../../../../../utils/ServicesAPIUtils';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import { notificationManager } from '../../../../../utils/NotificationUtils';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import useOutsideAlerter from '../../../../../custom-hooks/useOutsideAlerter';
import { SaveButton } from '../../../../../shared/custom-dragdrop/Save-Button';
import { handleOnDragEnd } from '../../../../../shared/custom-dragdrop/dragDrop';
import { createDataSortMapping } from '../../../../../utils/PropertyAPIUtils';
import MultipleDeleteConfirmationPopup from '../../../../../shared/MultiActionPopUp/MultiDeleteConfirmationPopup';
import ActionMenuList from '../../../../../shared/ActionMenuList/ActionMenuList';
import {
  PARTIAL_CHECKBOX_GREEN,
  ResetFilterList,
  getCheckedIds,
  updateCheckedStatus,
  updateSelectedModule,
  isDragDisabled,
} from '../../../../../utils/formUtils';
import { generateConfirmationMessage } from '../../../../../utils/formUtils';
import BulkActionCheckBox from '../../../../../shared/MultiActionPopUp/BulkActionCheckBox';
import MultipleSelectionAlert from '../../../../../shared/MultiActionPopUp/MultipleSelectionAlert';
import { decryptLocalStorage } from '../../../../../utils/authUtils';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../../utils/loaderSlice';

const PersonalisationList = (props) => {
  const {
    onDrawerToggle,
    onViewToggle,
    selectedHotel,
    permissions,
    page,
    rowsPerPage,
    onsetRowsPerPage,
    onsetPage,
  } = props;
  const currency = useSelector(selectedHotelCurrencySelector);
  const [selectedValue, setSelectedValue] = useState({
    id: '',
    name: '',
    title: '',
    description: '',
    status: false,
    anchorEl: null,
  });
  const originalPersonalisations = useSelector(allPersonalisationsSelector);
  const [personalisations, setPersonalisation] = useState();
  const [filteredBaseList, setFilteredBaseList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterMenu, setFilterMenu] = useState([]);
  const [filterTargetButton, setFilterTargetButton] = useState(null);
  const dispatch = useDispatch();
  const wrapperRef = useRef(null);
  const searchRef = useRef(null);
  const filterRef = useRef(null);
  const [popUp, setPopUp] = useState(false);
  const [visible, setVisible] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [searchButton, setSearchButton] = useState(true);
  const [actionMenuAnchorEl, setActionMenuAnchorEl] = useState(null);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [actionMenuList, setActionMenuList] = useState([]);
  const [actionName, setActionName] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [showMultipleDeleteConfirmation, setShowMultipleDeleteConfirmation] = useState(false);
  const [showBulkActiveDeactiveConfirmation, setShowBulkActiveDeactiveConfirmation] =
    useState(false);
  const [showBulkSearchAlert, setShowBulkSearchAlert] = useState(false);
  const [showBulkKebabSelectionAlert, setShowBulkKebabSelectionAlert] = useState(false);
  const [showBulkFilterAlert, setShowBulkFilterAlert] = useState(false);
  const isFilterApplied = useRef(false);
  const prevHotelIdRef = useRef(selectedHotel);

  const resetFilterDataList = () => {
    setFilterMenu([
      {
        title: 'All',
        field: 'all',
        subMenu: [],
      },
      {
        title: 'Status',
        field: 'isActive',
        subMenu: [
          { id: 'active', name: 'Active', selected: false },
          { id: 'inactive', name: 'Inactive', selected: false },
        ],
      },
    ]);
  };

  useEffect(() => {
    setPersonalisation(
      originalPersonalisations?.map((personalisation) => {
        return {
          ...personalisation,
          isChecked: false,
        };
      }),
    );
    resetFilterDataList();
    setLoading(false);
    setFilteredBaseList(originalPersonalisations);
    setSearchText('');
    setSearchButton(true);
  }, [originalPersonalisations]);

  useEffect(() => {
    updateSelectedModule(personalisations, setActionMenuList, setIsAllSelected);
  }, [personalisations]);

  useEffect(() => {
    if (loading || personalisations?.length === 0) return;
    const totalItems = personalisations?.length;
    const maxPageIndex = Math.max(Math.ceil(totalItems / rowsPerPage) - 1, 0);
    if (page > maxPageIndex) {
      onsetPage(maxPageIndex);
    }
  }, [personalisations?.length, rowsPerPage, page, onsetPage]);

  useEffect(() => {
    if (prevHotelIdRef?.current !== selectedHotel) {
      onsetPage(0);
    }
    prevHotelIdRef.current = selectedHotel;
  }, [selectedHotel]);

  const getCheckedPersonList = personalisations?.filter((person) => person?.isChecked);
  const listOfPersonIds = getCheckedPersonList?.map((person) => person?.id);
  const selectedPersonLength = getCheckedPersonList?.length;

  const handleSearchText = (searchText) => {
    setSearchText(searchText);
    const checkedIdList = getCheckedIds(personalisations, 'isChecked');
    const filteredRows = filteredBaseList.filter((item) =>
      item.name?.toLowerCase().includes(searchText.toLowerCase()),
    );
    const updatedCheckedList = updateCheckedStatus(filteredRows, checkedIdList);
    onsetPage(0);
    setPersonalisation(updatedCheckedList);
  };

  const handleChangePage = (event, newPage) => {
    onsetPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    onsetRowsPerPage(parseInt(event.target.value, 10));
    onsetPage(0);
  };

  const onOpenDrawer = (event, type) => {
    if (selectedPersonLength) {
      setPersonalisation(ResetFilterList);
    }
    event.stopPropagation();
    onDrawerToggle(type, true, selectedValue.personalisation);
    handleClose();
  };

  const handleClose = () => {
    setSelectedValue({
      id: '',
      name: '',
      title: '',
      description: '',
      status: false,
      anchorEl: null,
      personalisation: null,
    });
  };

  const handleCellMenuClick = (event, personalisation) => {
    event.stopPropagation();
    if (selectedPersonLength > 1) {
      setShowBulkKebabSelectionAlert(true);
    } else {
      setSelectedValue({
        id: personalisation.id,
        name: personalisation.name,
        title: '',
        description: '',
        status: false,
        isActive: personalisation.isActive,
        anchorEl: event.currentTarget,
        personalisation: personalisation,
      });
    }
  };

  const deleteAccommodationPersonalization = async (e) => {
    e.preventDefault();
    setSelectedValue((prev) => ({
      ...prev,
      title: 'Are you sure you want to delete',
      description: 'This action cannot be reversed',
      status: true,
      anchorEl: null,
    }));
  };

  const deletePersonalisation = async () => {
    try {
      const lang = decryptLocalStorage('lang');
      const delByLang = lang !== 'en' ? lang : '';
      if (selectedHotel && selectedValue && selectedValue.id) {
        await deleteAccommodationPersonalizationAPI(selectedHotel, selectedValue.id, delByLang);
        dispatch(fetchAllAccommodations(selectedHotel));
        notificationManager('success', 'Personalisation deleted successfully');
      }
      handleClose();
    } catch (e) {
      if (e.graphQLErrors) {
        notificationManager('danger', e.graphQLErrors[0].message);
      } else {
        notificationManager('danger', 'Failed to delete Personalisation');
      }
      handleClose();
    }
    setIsAllSelected(false);
    setActionMenuList([]);
  };
  const handleActivate = async () => {
    handleClose();
    const selectedLanguage = decryptLocalStorage('lang');
    const language = selectedLanguage !== 'en' ? selectedLanguage : '';
    if (selectedValue.isActive) {
      try {
        await accommodationPersonalizationDeactivate(selectedValue.id, selectedHotel, language);
        dispatch(fetchAllAccommodations(selectedHotel));
        notificationManager('success', 'Personalisation deactivated successfully');
        setSelectedValue({
          id: '',
          name: '',
          title: '',
          description: '',
          status: false,
          anchorEl: null,
          personalisation: null,
        });
      } catch (e) {
        notificationManager(
          'danger',
          e.graphQLErrors ? e.graphQLErrors[0].message : 'Personalisation deactivated failed',
        );
      }
    } else {
      try {
        await accommodationPersonalizationActivate(selectedValue.id, selectedHotel, language);
        dispatch(fetchAllAccommodations(selectedHotel));
        notificationManager('success', 'Personalisation activated successfully');
        setSelectedValue({
          id: '',
          name: '',
          title: '',
          description: '',
          status: false,
          anchorEl: null,
          personalisation: null,
        });
      } catch (e) {
        notificationManager(
          'danger',
          e.graphQLErrors ? e.graphQLErrors[0].message : 'Personalisation activated failed',
        );
      }
    }
    setIsAllSelected(false);
    setActionMenuList([]);
  };

  const onDeleteCancel = () => {
    setSelectedValue({
      id: '',
      name: '',
      title: '',
      description: '',
      status: false,
      anchorEl: null,
    });
  };

  const onViewDetails = (view, e) => {
    if (e?.target?.tagName === 'TD') {
      onViewToggle(PERSONALISATION_VIEW, true, view);
    }
  };

  const onClickView = (e) => {
    if (selectedValue && selectedValue.personalisation) {
      onViewToggle(PERSONALISATION_VIEW, true, selectedValue.personalisation);
    }
  };

  const handleFilterMenu = (event) => {
    if (selectedPersonLength > 0) {
      setShowBulkFilterAlert(true);
      return;
    } else {
      setFilterTargetButton(event.currentTarget);
    }
  };

  const handleFilter = (filterItems, field) => {
    const updatedMenu = filterMenu?.map((menu) =>
      menu.field === field ? { ...menu, subMenu: filterItems } : menu,
    );
    setFilterMenu(updatedMenu);
    const nothingSelected =
      field !== 'all' && filterItems?.every((item) => item?.selected === false);

    if (field === 'all' || nothingSelected) {
      setFilteredBaseList(originalPersonalisations);
      setPersonalisation(originalPersonalisations);
      resetFilterDataList();
      isFilterApplied.current = false;
      onsetPage(0);
      return;
    }
    isFilterApplied.current = true;
    const activeSelected = filterItems.some((o) => o.id === 'active' && o.selected);
    const inActiveSelected = filterItems.some((o) => o.id === 'inactive' && o.selected);
    let filteredRows;

    if ((activeSelected && inActiveSelected) || (!activeSelected && !inActiveSelected)) {
      filteredRows = originalPersonalisations;
    } else if (activeSelected) {
      filteredRows = originalPersonalisations?.filter((item) => item?.isActive);
    } else {
      filteredRows = originalPersonalisations?.filter((item) => !item?.isActive);
    }
    onsetPage(0);
    setFilteredBaseList(filteredRows);
    setPersonalisation(filteredRows);
  };

  useOutsideAlerter(wrapperRef, visible, setPopUp);

  const handleActionMenuOpen = (event) => {
    setActionMenuAnchorEl(event.currentTarget);
  };

  const handleActionMenuClose = () => {
    setActionMenuAnchorEl(null);
  };

  const handleAction = (actionName) => {
    let selectedDiscount = personalisations?.filter((item) => item?.isChecked);
    switch (actionName) {
      case 'Delete':
        if (selectedDiscount?.length > 0) {
          setShowMultipleDeleteConfirmation(true);
          setActionName('delete');
        }
        break;
      case 'Activate':
        if (selectedDiscount?.length > 0) {
          setShowBulkActiveDeactiveConfirmation(true);
          setActionName('activate');
          setIsActive(true);
        }
        break;
      case 'Deactivate':
        if (selectedDiscount?.length > 0) {
          setShowBulkActiveDeactiveConfirmation(true);
          setActionName('deactivate');
          setIsActive(false);
        }
        break;
      default:
        break;
    }
  };

  const handleCheckboxChange = (id) => {
    let actionListName = [];
    let index = personalisations?.findIndex((item) => item.id === id);
    if (!personalisations[index]?.isChecked) {
      personalisations[index] = { ...personalisations[index], isChecked: true };
    } else {
      personalisations[index].isChecked = !personalisations[index]?.isChecked;
    }
    setPersonalisation([...personalisations]);

    let actionList = personalisations
      ?.filter((sInfo) => sInfo?.isChecked)
      .map((status) => status?.isActive);

    const checkedItems = personalisations?.filter((combosList) => combosList?.isChecked);

    if (checkedItems.length === 0) {
      setActionMenuList([]);
      setIsAllSelected(false);
      return;
    }

    const isActiveSelected = actionList.includes(true);
    const isInactiveSelected = actionList.includes(false);

    if (isActiveSelected && isInactiveSelected) {
      actionListName.push('Activate', 'Deactivate');
    } else if (isActiveSelected) {
      actionListName.push('Deactivate');
    } else if (isInactiveSelected) {
      actionListName.push('Activate');
    }

    const isAllSelected = personalisations?.every((item) => item?.isChecked);
    setIsAllSelected(isAllSelected);
    if (!personalisations[index].isChecked && !actionList?.some((item) => item?.isChecked)) {
      setActionMenuList([]);
    }
    setActionMenuList(actionListName);
  };

  const handleSelectAll = (event) => {
    let selectedMenuList = [];
    let actionListName = [];
    const CheckedValue = event?.target?.checked;
    setIsAllSelected(CheckedValue);
    selectedMenuList = personalisations?.map((item) => {
      return {
        ...item,
        isChecked: CheckedValue,
      };
    });

    const isActive = selectedMenuList?.some((restaurant) => restaurant?.isActive);
    const isInactive = selectedMenuList?.some((restaurant) => !restaurant.isActive);

    if (isActive && !actionListName?.includes('Deactivate')) {
      actionListName.push('Deactivate');
    }
    if (isInactive && !actionListName?.includes('Activate')) {
      actionListName.push('Activate');
    }

    setPersonalisation([...selectedMenuList]);

    const sortActionMenuList = actionListName.sort((a, b) => {
      const order = { Activate: 1, Deactivate: 2, Delete: 3 };
      return order[a] - order[b];
    });

    setActionMenuList(sortActionMenuList);

    if (!event?.target?.checked && !selectedMenuList?.some((item) => item?.isChecked)) {
      setActionMenuList([]);
    }
  };

  const onApiCallConfirmationNotification = generateConfirmationMessage(
    'Personalisation',
    getCheckedPersonList?.length,
    isActive,
  );

  const handleMultipleStatusChange = async () => {
    handleClose();
    setActionMenuList([]);
    try {
      dispatch(stepUpLoaderCount());
      setLoading(true);
      const filterApplied = searchText?.length > 0 || isFilterApplied?.current ? true : false;
      const lang = decryptLocalStorage('lang');
      const selectedLang = lang !== 'en' ? lang : '';
      const moduleName = 'ACCOMMODATION_PERSONALISATION';
      await updateSelectedItemsStatus(
        listOfPersonIds,
        selectedHotel,
        selectedLang,
        moduleName,
        '',
        isActive,
        filterApplied ? false : isAllSelected,
      );
      dispatch(fetchAllAccommodations(selectedHotel));
      notificationManager('success', onApiCallConfirmationNotification);
      setSelectedValue({
        id: '',
        name: '',
        title: '',
        description: '',
        status: false,
        activate: false,
        brand: null,
      });
      setLoading(false);
    } catch (e) {
      notificationManager(
        'danger',
        e.graphQLErrors
          ? e.graphQLErrors[0].message
          : 'The status of the Personalisation was not changed',
      );
    } finally {
      dispatch(stepDownLoaderCount());
    }

    setIsAllSelected(false);
    setPersonalisation(ResetFilterList);
  };

  const deleteMultipleSelection = async () => {
    handleClose();
    try {
      setLoading(true);
      const filterApplied = searchText.length > 0 || isFilterApplied?.current ? true : false;
      const lang = decryptLocalStorage('lang');
      const selectedLang = lang !== 'en' ? lang : '';
      const moduleName = 'ACCOMMODATION_PERSONALISATION';
      await deleteSelectedItems(
        listOfPersonIds,
        selectedHotel,
        selectedLang,
        moduleName,
        '',
        filterApplied ? false : isAllSelected,
      );
      dispatch(fetchAllAccommodations(selectedHotel));
      notificationManager('success', 'Personalisation deleted successfully');
      setSelectedValue({
        ...selectedValue,
        id: '',
        name: '',
        title: '',
        description: '',
        status: false,
        brand: null,
      });
      setLoading(false);
    } catch (e) {
      notificationManager(
        'danger',
        e.graphQLErrors ? e.graphQLErrors[0].message : 'Failed to delete Personalisation',
      );
    }
    setIsAllSelected(false);
    setActionMenuList([]);
    setPersonalisation(ResetFilterList);
  };

  const handleContinue = (isFromFilterContinue = false) => {
    setShowBulkSearchAlert(false);
    setPersonalisation((prev) =>
      prev.map((item) => ({
        ...item,
        isChecked: false,
      })),
    );
    setTimeout(() => {
      if (isFromFilterContinue) {
        filterRef?.current?.click();
      } else {
        searchRef?.current?.focus();
      }
    }, 0);
  };

  const handleSearchInputFocus = (e) => {
    if (selectedPersonLength) {
      searchRef?.current?.blur();
      setShowBulkSearchAlert(true);
    } else {
      setShowBulkSearchAlert(false);
    }
  };

  const dragDisabled = isDragDisabled(personalisations, searchText) || isFilterApplied?.current;

  return (
    <div className='mt-4 mb-4 group-list-container'>
      {selectedValue.id && selectedValue.status === true && (
        <DeletePopupModel
          deletePopUp={selectedValue}
          onDelete={deletePersonalisation}
          onDeleteCancel={onDeleteCancel}
        />
      )}
      <div className='row mx-2 d-flex'>
        <div
          className='col-md-4'
          onClick={() => {
            visible && setPopUp(true);
          }}
        >
          <TextField
            className='w-100'
            onChange={(e) => {
              handleSearchText(e.target.value);
              setSearchButton(e?.target?.value ? false : true);
            }}
            onFocus={(e) => handleSearchInputFocus(e)}
            label='Search'
            inputRef={searchRef}
            focused={false}
            value={searchText}
            InputProps={
              searchButton && {
                endAdornment: (
                  <InputAdornment position='end'>
                    <IconButton className='showpopup'>
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }
            }
          />
        </div>
        <div className='col-md-8 d-flex justify-content-end'>
          {actionMenuList?.length !== 0 && (
            <div>
              <Button
                onClick={handleActionMenuOpen}
                variant='outlined'
                size='large'
                className='me-4 showpopup'
                endIcon={<ArrowDropDownIcon />}
              >
                Actions
              </Button>
              <ActionMenuList
                anchorEl={actionMenuAnchorEl ?? null}
                handleClose={handleActionMenuClose}
                handleAction={handleAction}
                actionMenuItems={actionMenuList}
              />
            </div>
          )}
          <SaveButton
            visible={visible}
            setVisible={setVisible}
            popUp={popUp}
            setPopUp={setPopUp}
            placeHolder={personalisations}
            setPlaceHolder={setPersonalisation}
            globalPlaceHolder={originalPersonalisations}
            setGlobalPlaceHolder={setAllPersonalisations}
            dispatch={dispatch}
            mappingApi={createDataSortMapping}
            displayText='Accommodations personalisation'
            module='ACCOMMODATION_PERSONALISATION'
          />
          {personalisations && (
            <>
              <Button
                innerRef={filterRef}
                variant='outlined'
                color='secondary'
                size='large'
                endIcon={<ArrowDropDownIcon />}
                onClick={(e) => {
                  handleFilterMenu(e);
                }}
                className={
                  filterMenu?.some((f) => f?.subMenu?.some((s) => s?.selected))
                    ? 'me-4 filterButton'
                    : 'me-4 showpopup'
                }
              >
                Filter
              </Button>
              <ListFilterMenu
                menu={filterMenu}
                targetEl={filterTargetButton}
                handleFilterClose={() => setFilterTargetButton(null)}
                handleFilter={(items, field) => {
                  handleFilter(items, field);
                }}
                hideSearch={true}
              />
            </>
          )}
          {permissions[RBAC_TYPE_HOTEL_ACCOMMODATIONS] === RBAC_PERMISSION_LEVEL_FULL_ACCESS && (
            <Button
              variant='contained'
              color='primary'
              size='large'
              startIcon={<AddCircle />}
              onClick={(e) => {
                onOpenDrawer(e, PERSONALISATION_CREATE);
              }}
              className='showpopup'
            >
              Add Personalisation
            </Button>
          )}
        </div>
      </div>

      <div ref={wrapperRef} className='row mx-2 d-flex mt-4'>
        {loading ? (
          <div className='pt-4 col-md-12'>
            <LinearProgressBar />
          </div>
        ) : (
          personalisations && (
            <TableContainer>
              <Table className='list-table' aria-label='simple table'>
                <TableHead>
                  <TableRow>
                    <TableCell className={`w-5 ${dragDisabled ? '' : 'ps-5'}`}>
                      <BulkActionCheckBox
                        onChange={handleSelectAll}
                        checked={isAllSelected || false}
                        selectedLength={selectedPersonLength}
                        totalLength={originalPersonalisations?.length}
                        inputProps={{
                          'aria-label': 'select all personalisations',
                        }}
                        className={PARTIAL_CHECKBOX_GREEN}
                      />
                    </TableCell>
                    <TableCell className='w-30'>Personalisation name</TableCell>
                    <TableCell className='w-10' align='right'>
                      Unit
                    </TableCell>
                    <TableCell align='right' className='w-20'>
                      Cost
                    </TableCell>
                    <TableCell align='center' className='w-30'>
                      Status
                    </TableCell>
                    <TableCell align='right' className='w-10'></TableCell>
                  </TableRow>
                </TableHead>

                <DragDropContext
                  onDragEnd={(event) =>
                    handleOnDragEnd(
                      event,
                      setVisible,
                      personalisations,
                      setPersonalisation,
                      false,
                      page,
                      rowsPerPage,
                    )
                  }
                  isDropDisabled={dragDisabled}
                >
                  <Droppable droppableId='spas' isDropDisabled={dragDisabled}>
                    {(provided) => (
                      <TableBody {...provided.droppableProps} ref={provided.innerRef}>
                        {(rowsPerPage > 0
                          ? personalisations.slice(
                              page * rowsPerPage,
                              page * rowsPerPage + rowsPerPage,
                            )
                          : personalisations
                        ).map((item, i) => (
                          <Draggable
                            key={item.id}
                            draggableId={item.id}
                            index={i}
                            isDragDisabled={dragDisabled}
                          >
                            {(provided) => (
                              <TableRow
                                key={i}
                                className='border-white pointer'
                                onClick={(e) => {
                                  onViewDetails(item, e);
                                }}
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                              >
                                <TableCell className='w-12'>
                                  {!dragDisabled && (
                                    <span style={{ marginRight: 1.5 }}>
                                      <DragIndicator className='res-menu-accordion-drag' />
                                    </span>
                                  )}
                                  <Checkbox
                                    onChange={(event) => handleCheckboxChange(item?.id)}
                                    checked={item?.isChecked || false}
                                    inputProps={{
                                      'aria-label': `select personalisations ${item?.id}`,
                                    }}
                                  />
                                </TableCell>
                                <TableCell className='w-30'>{item?.name}</TableCell>
                                <TableCell className='w-10' align='right'>
                                  {item?.unit}
                                </TableCell>
                                <TableCell className='w-20' align='right'>
                                  {currency} {item?.cost}
                                </TableCell>
                                <TableCell className='w-30' align='center'>
                                  <CustomChip
                                    label={item?.isActive ? 'Active' : 'Inactive'}
                                    color={item?.isActive ? 'primary' : 'default'}
                                  />
                                </TableCell>
                                <TableCell className='kebab-menu w-10' align='right'>
                                  {permissions[RBAC_TYPE_HOTEL_ACCOMMODATIONS] ===
                                    RBAC_PERMISSION_LEVEL_FULL_ACCESS && (
                                    <Button
                                      aria-controls='simple-menu'
                                      aria-haspopup='true'
                                      onClick={(e) => {
                                        handleCellMenuClick(e, item);
                                      }}
                                      className='showpopupInner'
                                    >
                                      <MoreHoriz className='showpopupInner' />
                                    </Button>
                                  )}
                                  <Menu
                                    id={i}
                                    anchorEl={selectedValue?.anchorEl}
                                    disableRestoreFocus
                                    MenuListProps={{ autoFocusItem: false }}
                                    keepMounted
                                    open={
                                      Boolean(selectedValue.anchorEl) &&
                                      selectedValue.id === item.id
                                    }
                                    onClose={handleClose}
                                    className='shadow'
                                  >
                                    <MenuItem
                                      className='pe-4'
                                      onClick={(e) => {
                                        handleActivate();
                                      }}
                                    >
                                      {selectedValue.isActive === true ? (
                                        <>
                                          <RemoveCircle className='me-2 action-menu-icon' />
                                          Deactivate
                                        </>
                                      ) : (
                                        <>
                                          <AddCircle className='me-2 action-menu-icon' />
                                          Activate
                                        </>
                                      )}
                                    </MenuItem>
                                    <MenuItem
                                      className='pe-4'
                                      onClick={(e) => {
                                        onOpenDrawer(e, PERSONALISATION_EDIT);
                                      }}
                                    >
                                      <CreateIcon className='me-2 action-menu-icon' />
                                      Edit
                                    </MenuItem>
                                    <MenuItem
                                      className='pe-4'
                                      onClick={(e) => {
                                        onClickView(e);
                                      }}
                                    >
                                      <VisibilityIcon className='me-2 action-menu-icon' />
                                      View
                                    </MenuItem>
                                    <MenuItem
                                      className='pe-4'
                                      onClick={(e) => {
                                        deleteAccommodationPersonalization(e);
                                      }}
                                    >
                                      <DeleteForeverIcon className='me-2 action-menu-icon' />
                                      Delete
                                    </MenuItem>
                                  </Menu>
                                </TableCell>
                              </TableRow>
                            )}
                          </Draggable>
                        ))}
                        {provided.placeholder}
                      </TableBody>
                    )}
                  </Droppable>
                </DragDropContext>
                <TableFooter>
                  <TableRow className='paginator'>
                    <TablePagination
                      rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                      count={personalisations.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      SelectProps={{
                        inputProps: { 'aria-label': 'rows per page' },
                        native: true,
                      }}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      ActionsComponent={TablePaginationActions}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          )
        )}
        {showMultipleDeleteConfirmation && (
          <MultipleDeleteConfirmationPopup
            title={`Are you sure you want to ${actionName} this selection?`}
            subTitle={`A selection of ${selectedPersonLength} ${
              selectedPersonLength > 1 ? 'personalisations' : 'personalisation'
            } will be ${actionName}d. This Action is irreversible.`}
            isOpen={showMultipleDeleteConfirmation}
            onClose={() => setShowMultipleDeleteConfirmation(false)}
            onConfirm={() => {
              deleteMultipleSelection();
            }}
            leftButtonName={'Cancel'}
            rightButtonName={'Delete'}
          />
        )}
        {showBulkActiveDeactiveConfirmation && (
          <MultipleDeleteConfirmationPopup
            title={`Are you sure you want to ${actionName} this selection?`}
            subTitle={`A selection of ${selectedPersonLength}  ${
              selectedPersonLength > 1 ? 'personalisations' : 'personalisation'
            } will be ${actionName}d.`}
            isOpen={showBulkActiveDeactiveConfirmation}
            onClose={() => setShowBulkActiveDeactiveConfirmation(false)}
            onConfirm={() => {
              handleMultipleStatusChange();
            }}
            leftButtonName={'No'}
            rightButtonName={'Yes'}
          />
        )}
        {showBulkSearchAlert && (
          <MultipleSelectionAlert
            isOpen={showBulkSearchAlert}
            message="If you perform a search after making selections, the items you've selected will be lost."
            leftButtonName='Cancel'
            rightButtonName='Continue'
            onClose={() => setShowBulkSearchAlert(false)}
            onConfirm={handleContinue}
          />
        )}
        {showBulkKebabSelectionAlert && (
          <MultipleSelectionAlert
            isOpen={showBulkKebabSelectionAlert}
            onClose={() => setShowBulkKebabSelectionAlert(false)}
            message='Please select one item from the list that you want to edit.'
            centerButtonName='OK'
          />
        )}
        {showBulkFilterAlert && (
          <MultipleSelectionAlert
            isOpen={showBulkFilterAlert}
            onClose={() => setShowBulkFilterAlert(false)}
            message="If you perform a filter after making selections, the items you've selected will be lost."
            leftButtonName='Cancel'
            rightButtonName='Continue'
            onConfirm={() => {
              handleContinue(true);
            }}
          />
        )}
      </div>
    </div>
  );
};

export default PersonalisationList;
